export default __webpack_public_path__ + "static/media/seguro_residencial.ddb36d11.png";